import style from './comparing-dedicated-team.module.scss';
import template from '@components/services/services.module.scss';
import {
  IComparingDedicatedTeamModel,
  IComparingDedicatedTeamSection,
} from '@components/services/dedicated-teams/dedicated-teams.state';
import { useState } from 'react';
import { ComparingTable } from '@components/services/dedicated-teams/sections/comparing-dedicated-team/comparing-table/comparing-table';
import { TabSlider } from '@components/shared/tab-slider/tab-slider';

const ComparingDedicatedTeamSection = ({ title, models }: IComparingDedicatedTeamSection) => {
  const [activeIndex, setActiveIndex] = useState(0);
  return (
    <section className={`${style.section} ${template.section_gray}`}>
      <div className={`${template.container} ${template.container_small} ${style.container}`}>
        <h2 className={`${template.title} ${template.title_large} ${style.title}`}>{title}</h2>
      </div>
      <div className={`${template.container} ${template.container_large}`}>
        <TabSlider
          items={models.map((m) => ({ title: m.tabTitle }))}
          activeIndex={activeIndex}
          onChange={setActiveIndex}
        />

        <div className={`${style.technologies__table}`}>
          {models.map((item: IComparingDedicatedTeamModel, index: number) => {
            return (
              <ComparingTable
                key={index}
                title={item.tabTitle}
                description={item.description}
                tables={item.tables}
                isActive={models[activeIndex].tabTitle}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ComparingDedicatedTeamSection;
